import Tooltip from '@mui/material/Tooltip'
import cloudBlue from '@/assets/img/cloud-blue.png'
import cloudGray from '@/assets/img/cloud-gray.png'
import cloudRed from '@/assets/img/cloud-red.png'
import dayjs from 'dayjs'
import * as React from 'react'
import { Box } from '@mui/material'

const ConnectionStatus = ({
  connectionStatus,
  lastPackageDate,
}: {
  connectionStatus?: number
  lastPackageDate?: any
}) => {
  let textColor = '#0072BC'
  if (connectionStatus === 2) {
    textColor = '#666'
  }
  return (
    <Box
      sx={{
        whiteSpace: 'nowrap',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        color: textColor,
      }}
    >
      {connectionStatus === 1 ? (
        <>
          <Tooltip
            title={'Состояние подключения'}
            placement='top'
          >
            <img
              width={25}
              height={25}
              src={cloudBlue}
              alt='В сети'
            />
          </Tooltip>
          <span>В сети</span>
        </>
      ) : connectionStatus === 2 ? (
        <>
          <Tooltip
            title={'Состояние подключения'}
            placement='top'
          >
            <img
              width={25}
              height={25}
              src={cloudGray}
              alt='Не в сети'
            />
          </Tooltip>
          <span>Не в сети</span>
        </>
      ) : connectionStatus === 3 ? (
        <>
          <Tooltip
            title={'Состояние подключения'}
            placement='top'
          >
            <img
              width={25}
              height={25}
              src={cloudRed}
              alt='Нет соединения'
            />
          </Tooltip>
          <span>
            {lastPackageDate
              ? dayjs(lastPackageDate).format('DD.MM.YYYY HH:mm')
              : 'Нет соединения'}
          </span>
        </>
      ) : null}
    </Box>
  )
}

export default ConnectionStatus
